'use strict';

(function (getours) {

    getours.Navigation = {};

}(window.getours = window.getours || {}));